module.exports = __webpack_public_path__ + "static/media/ph_g05.5f0612ca.jpg";